import styled from 'styled-components';

export default function ControlOnebyOne({
  isOn,
  setIsOn,
  disabled,
}: {
  isOn: boolean;
  setIsOn: (value: boolean) => void;
  disabled: boolean;
}) {
  return (
    <Wrapper>
      <SwitchButton
        isOn={isOn}
        disabled={disabled}
        onClick={() => !disabled && setIsOn(!isOn)} // 비활성화 시 클릭 불가
      >
        <Circle isOn={isOn} />
        <Label isOn={isOn}>{isOn ? 'ON' : 'OFF'}</Label>
      </SwitchButton>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const SwitchButton = styled.button<{ isOn: boolean; disabled: boolean }>`
  width: 44px;
  height: 24px;
  border-radius: 32px;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: ${({ isOn }) => (isOn ? 'flex-end' : 'flex-start')};
  background-color: ${({ isOn }) => (isOn ? '#111' : '#ccc')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  position: relative;
  transition:
    background-color 0.3s ease,
    justify-content 0.3s ease;
`;

const Circle = styled.div<{ isOn: boolean }>`
  width: 18px;
  height: 18px;
  background-color: #fff;
  border-radius: 50%;
  margin: 2px;
  transition: transform 0.3s ease;
`;

const Label = styled.span<{ isOn: boolean }>`
  position: absolute;
  font-size: 8px;
  font-weight: 600;
  color: #fff;
  left: ${({ isOn }) => (isOn ? '6px' : 'auto')};
  right: ${({ isOn }) => (isOn ? 'auto' : '6px')};
  transition: all 0.3s ease;
  pointer-events: none;
`;
